import { NotFound } from './theme/NotFound';
import { useParams } from 'react-router-dom';
import { AcademicInformation } from './Talentohumano/GestionTH/AcademicInformation/AcademicInformation';
import { WorkExperience } from './Talentohumano/GestionTH/WorkExperience/WorkExperience';
import { FamilyGroup } from './Talentohumano/GestionTH/FamilyGroup/FamilyGroup';
import { WorkIncentives } from './Talentohumano/GestionTH/WorkIncentives/WorkIncentives';
import { Fortnight } from './admin/configuracion/Fortnight/Fortnight';
import { AnnotationReport } from './Talentohumano/ParametrosTalentoHumano/AnnotationReport/AnnotationReport';
import { EmployeeDecoration } from './Talentohumano/ParametrosTalentoHumano/EmployeeDecoration/EmployeeDecoration';
import { Absenteeism } from './Talentohumano/ParametrosTalentoHumano/Absenteeism/Absenteeism';
import { SocialResponsibility } from './Talentohumano/ParametrosTalentoHumano/SocialResponsibility/SocialResponsibility';
import { Comparison } from './Talentohumano/ParametrosTalentoHumano/Comparison/Comparison';
import { BodyMeasurements } from './Talentohumano/ParametrosTalentoHumano/BodyMeasurements/BodyMeasurements';
import { FortnightLiquidation } from './Talentohumano/GestionTH/Fortnight/FortnightLiquidation';
import { EnjoyedVacationERP } from './Talentohumano/payRoll/EnjoyedVacationERP';
import { ConsultEmployeesInCharge } from './Talentohumano/GestionTH/ConsultEmployeesInCharge/ConsultEmployeesInCharge';
import { DisabilityCodes } from './Talentohumano/GestionTH/EmployeeContract/DisabilityCodes/DisabilityCodes';
import { TypeNovelty } from './Talentohumano/Novelty/TypeNovelty/TypeNovelty';
import { NoveltyAccount } from './Talentohumano/Novelty/NoveltyAccount/NoveltyAccount';
import { Phva } from './Talentohumano/phva/Phva';
import { JobRequisition } from './Talentohumano/GestionTH/PaymentAccount/JobRequisition/JobRequisition';
import { PerformanceEvaluationPeriod } from './Talentohumano/EvaluationPeriod/PerformanceEvaluationPeriod/PerformanceEvaluationPeriod';
import { TrainingRequest } from './Talentohumano/GestionTH/PaymentAccount/TrainingRequest/TrainingRequest';
import { EmployeeBenefit } from './Talentohumano/ParametrosTalentoHumano/EmployeeBenefit/EmployeeBenefit';

export const RouterHumanResources = (props: any) => {

    const { module, view }: any = useParams();

    const renderSwitch = (url: string) => {

        switch (url) {
            case 'informacion-academica':
                return <AcademicInformation />;
            case 'experiencia-laboral':
                return <WorkExperience />;
            case 'reporte-anotacion':
                return <AnnotationReport />;
            case 'personal-ausente':
                return <Absenteeism />;
            case 'condecoraciones':
                return <EmployeeDecoration />;
            case 'tallas-funcionario':
                return <BodyMeasurements />;
            case 'comparendos':
                return <Comparison />;
            case 'responsabilidad-social':
                return <SocialResponsibility />;
            case 'grupo-familiar':
                return <FamilyGroup />;
            case 'factor-salarial':
                return <Fortnight />;
            case 'incentivo-laboral':
                return <WorkIncentives />;
            case 'incapacidades-laborales':
                return <FortnightLiquidation />;
            case "disfrute-vacaciones":
                return <EnjoyedVacationERP rol={1} />;
            case "empleados-acargo":
                return <ConsultEmployeesInCharge />;
            case "codigos-incapacidades":
                return <DisabilityCodes />;
            case "tipos-novedades-permisos":
                return <TypeNovelty />;
            case "solicitudes-permisos":
                return <NoveltyAccount />;
            case "phva":
                return <Phva isAdmin={true} />;
            case "consulta-phva":
                return <Phva />;
            case "solicitudes-contratacion":
                return <JobRequisition />;
            case "solicitudes-capacitacion":
                return <TrainingRequest />;
            case "periodos-evaluacion":
                return <PerformanceEvaluationPeriod />;
            case "tipos-beneficios-empleados":
                return <PerformanceEvaluationPeriod />;
            case "tipos-beneficio-empleados":
                return <EmployeeBenefit />;
            default:
                return <NotFound />;
        }
    }

    return (
        <div className=''>
            {renderSwitch(view)}
        </div>
    );
}